import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One brand per article — and it stops at what the code means', 'Video courses that teach you to think, but leave nothing in the van', 'Blank checklists with no test order, no expected reading, no code reference', 'No way to split the system, so you guess, swap and come back', 'Reports and warranty paperwork from scratch on every call'];
const withIt = ['159 cards: symptom, code, split, prove, fix & file', 'The safe test order and the expected reading on every card', 'Code columns for the US, Canada, UK and Australia', '40 worksheets, from intake sheet to warranty claim packet', 'One fault per horizontal page, readable on your phone'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="topo-light w-full bg-paper" data-id="element-420" data-mp="30yeq0r24g1gn">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-421" data-mp="30wk1z3vjzt8c">
        <div className="text-center" data-id="element-422" data-mp="35pwp19kl3ryz">
          <p className="eyebrow text-ember-deep" data-id="element-423" data-mp="35qy3zp4q0ylz">
            Why this isn&apos;t another code list
          </p>
          <h2 id="vs-heading" className="trail-underline mt-3 font-display text-[34px] leading-tight text-pine sm:text-6xl" data-id="element-424" data-mp="1ogjttzqi55a9">
            Error-code lists vs{' '}
            <span className="text-forest" data-id="element-425" data-mp="1yeg0ae8hvc21">a diagnostic system</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-426" data-mp="1ycmv73dj4zw5">
            Yes, every manufacturer posts its codes and there are good video
            courses out there. Knowing what a code means was never the hard
            part — proving where the fault really is, safely, and closing the
            call with the right paperwork is. That&apos;s the part this does for
            you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-paper-dark shadow-card" data-id="element-427" data-mp="rphlt8yyqw05">
          <div className="bg-signal px-3.5 py-4 text-white sm:p-6" data-id="element-428" data-mp="mrpq03v76pqo">
            <span className="font-display text-3xl leading-none sm:text-4xl" data-id="element-429" data-mp="2mt5x51maomwr">
              Code lists
            </span>
            <p className="mt-1 font-mono text-[10px] font-bold uppercase tracking-wider text-white/85 sm:text-[11px]" data-id="element-430" data-mp="2rrh494l7gjba">
              Free guides &amp; forms
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-431" data-mp="30sxftfnrarh3">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-white/95 sm:text-sm" data-id="element-432" data-mp="30qkqghfo5eu0">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-433" data-mp="3apa766vtwt8o">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-434" data-mp="3fk7e989jssix" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-forest px-3.5 py-4 text-white sm:p-6" data-id="element-435" data-mp="3ogopscltqsf7">
            <span className="font-display text-3xl leading-none sm:text-4xl" data-id="element-436" data-mp="3ti4bm6vtt2yn">
              A system
            </span>
            <p className="mt-1 font-mono text-[10px] font-bold uppercase tracking-wider text-ember sm:text-[11px]" data-id="element-437" data-mp="7e2cwa3thv6o">
              Diagnostic Pro
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-438" data-mp="3toeoefbrj7w0">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug sm:text-sm" data-id="element-439" data-mp="3pmjsxrgijoq5">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-moss" data-id="element-440" data-mp="l7jv9rkrp1v4">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-441" data-mp="ggbm8wncniih" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}